import { HOSTED_MODE } from "@/lib/config";

export function isHostedMode(): boolean {
  return HOSTED_MODE;
}

export function ensureLocalMode(message: string): void {
  if (HOSTED_MODE) {
    throw new Error(message);
  }
}

/**
 * The fork branched every API module on hosted vs local. sphinx has no hosted
 * plane, so this runs `local` and the `hosted` arm is gone — a hosted branch
 * could only point at an `/api/web/*` route this server never mounts.
 */
export async function runByMode<T>(options: {
  local: () => Promise<T>;
}): Promise<T> {
  return options.local();
}
